import { DEFAULT_LOCALE, LOCALES } from '@/shared/constants/locales.constants'

const getBrowserLocale = (): string => {
  const foundLocale = Object.keys(LOCALES).find((locale: string) => navigator.language.startsWith(locale))
  return foundLocale ? foundLocale : DEFAULT_LOCALE
}

export default getBrowserLocale
